import { useState } from 'react';
import { BookOpen } from 'lucide-react';
import { clsx } from 'clsx';

type Props = {
  isbn: string | null;
  /** Klassen für den Rahmen, z. B. "h-16 w-12". */
  className?: string;
};

/**
 * Titelbild einer Position.
 *
 * Die Bilder kommen über `api/cover.php`, nicht direkt von der VLB-URL:
 * die VLB-Cover-Schnittstelle verlangt ein Bearer-Token und antwortet
 * zeitweise mit 503. Vorher stand die Roh-URL im `src`, und bei jeder
 * Störung zeigte jede Positionszeile ein kaputtes Bild (B83).
 *
 * Kein Cover ist der Normalfall, kein Fehler: der Proxy antwortet dann
 * mit 204, der Browser meldet `error`, und hier steht das Buchsymbol.
 */
export function Cover({ isbn, className }: Props) {
  const [kaputt, setKaputt] = useState(false);
  const rahmen = clsx(
    'flex shrink-0 items-center justify-center overflow-hidden rounded border border-line bg-cream-warm',
    className ?? 'h-16 w-12'
  );

  if (isbn === null || kaputt) {
    return (
      <div className={rahmen}>
        <BookOpen className="h-6 w-6 text-ink-faint" aria-hidden />
      </div>
    );
  }

  return (
    <div className={rahmen}>
      <img
        src={`/api/cover.php?isbn=${encodeURIComponent(isbn)}`}
        alt=""
        loading="lazy"
        onError={() => setKaputt(true)}
        className="h-full w-full object-cover"
      />
    </div>
  );
}
